import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Warning = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <rect x="3.5" y="3.5" width="13" height="13" rx="2" fill="currentColor" />;
    t1 = <path className="fill-card" d="M10.6938 6.5L10.5719 10.9811H9.42816L9.30317 6.5H10.6938ZM10 13.9811C9.79378 13.9811 9.6167 13.9081 9.46879 13.7623C9.32087 13.6144 9.24796 13.4373 9.25004 13.2311C9.24796 13.0269 9.32087 12.8519 9.46879 12.7061C9.6167 12.5603 9.79378 12.4874 10 12.4874C10.1979 12.4874 10.3719 12.5603 10.5219 12.7061C10.6719 12.8519 10.7479 13.0269 10.75 13.2311C10.7479 13.3686 10.7115 13.4946 10.6406 13.6092C10.5719 13.7217 10.4813 13.8123 10.3688 13.8811C10.2563 13.9477 10.1334 13.9811 10 13.9811Z" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default Warning;